import { render, staticRenderFns } from "./ruleAddOrEdit.vue?vue&type=template&id=3365d241&scoped=true"
import script from "./ruleAddOrEdit.vue?vue&type=script&lang=js"
export * from "./ruleAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./ruleAddOrEdit.vue?vue&type=style&index=0&id=3365d241&prod&scoped=true&lang=scss"
import style1 from "./ruleAddOrEdit.vue?vue&type=style&index=1&id=3365d241&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3365d241",
  null
  
)

export default component.exports